import callAPI from 'api'
import { getLiveCall } from 'services/liveCall'
import { GetLiveCallResponse } from 'services/types/live-call'
import { Fail, Success } from 'store/types'
import { LiveCallLog } from 'store/types/lead'

export const fetchLiveCallByLiveCallId = async (liveCallId: string): Promise<LiveCallLog | null> => {
  try {
    const response = await getLiveCall(liveCallId)

    if (response.status !== 'SUCCESS') {
      return null
    }

    const { data } = response.data

    const liveCallLog: LiveCallLog = {
      leadId: data.lead_id || '',
      createTs: data.create_ts,
      createdBy: data.created_by || '',
      createdByName: data.created_by_name || '',
      createdByPhoto: data.created_by_photo || '',
      liveCallId: data.live_call_id,
      contactInfo: {
        fname: data.fname || '',
        lname: data.lname || '',
        contactInfoId: data.contact_info_id || '',
        contactInfoTypeId: data.contact_info_type_id || '',
        contactValue: data.contact_value || '',
        isOtherNumber: !!data?.other_contact_info_type_id,
        isPrimaryContact: data.is_primary || false,
        otherContactInfoTypeId: data.other_contact_info_type_id || '',
        otherContactValue: data.other_contact_value || '',
      },
      callStatusOutcome: data.call_status || '',
      callStatusOutcomeId: data.outcome || '',
      callNote: '',
      isFirstCall: false,
      isCallbackScheduled: false,
      duration: data.duration || '',
      liveCallStatus: data.live_call_status || '',
      leadActivityId: data.lead_activity_id || '',
      recordingPath: data.recording_path || '',
      updateTs: data.update_ts || '',
      startTime: data.start_time || '',
      endTime: data.end_time || '',
      totalDuration: data.total_duration || '',
      connectionDuration: data.connection_duration || '',
      ringDuration: data.ring_duration || '',
      talkTimeDuration: data.talktime_duration || '',
    }

    return liveCallLog
  } catch (error) {
    console.error('Error fetching live call by ID:', error)
    return null
  }
}

export const fetchLiveCallByCallLogId = async (callLogId: string): Promise<LiveCallLog | null> =>
  await callAPI<GetLiveCallResponse, { call_log_id: string }>(
    'crm_get_live_call_by_call_log_id',
    [{ call_log_id: callLogId }],
    {
      requireAuthorization: true,
    },
  )
    .then((res: Success<GetLiveCallResponse> | Fail) => (res.status == 'SUCCESS' ? res.data : undefined))
    .then((res: GetLiveCallResponse | undefined) => {
      const data = res?.data
      if (!data) return null

      const liveCall: LiveCallLog = {
        createTs: data.create_ts,
        createdBy: data.created_by || '',
        createdByName: data.created_by_name || '',
        createdByPhoto: data.created_by_photo || '',
        liveCallId: data.live_call_id,
        contactInfo: {
          fname: data.fname || '',
          lname: data.lname || '',
          contactInfoId: data.contact_info_id || '',
          contactInfoTypeId: data.contact_info_type_id || '',
          contactValue: data.contact_value || '',
          isOtherNumber: data?.other_contact_info_type_id ? true : false,
          isPrimaryContact: data.is_primary || false,
          otherContactInfoTypeId: data.other_contact_info_type_id || '',
          otherContactValue: data.other_contact_value || '',
        },
        callStatusOutcome: data.call_status || '',
        callStatusOutcomeId: data.outcome || '',
        callNote: '',
        isFirstCall: false,
        isCallbackScheduled: false,
        duration: data.duration || '',
        liveCallStatus: data.live_call_status || '',
        leadActivityId: data.lead_activity_id || '',
        recordingPath: data.recording_path || '',
        updateTs: data.update_ts || '',
        startTime: data.start_time || '',
        endTime: data.end_time || '',
        totalDuration: data.total_duration || '',
        connectionDuration: data.connection_duration || '',
        ringDuration: data.ring_duration || '',
        talkTimeDuration: data.talktime_duration || '',
        leadId: data.lead_id,
      }
      return liveCall
    })
